module.exports = "/packs/coaching_guide_banner-1e179dcc1e1266a986b48ddf50774b12.png";